module.exports = __webpack_public_path__ + "static/media/content_rating_w.b2bf5c7f.svg";